import { render } from "./IconElectraRiderHeight.vue?vue&type=template&id=c1c94676"
import script from "./IconElectraRiderHeight.vue?vue&type=script&lang=js"
export * from "./IconElectraRiderHeight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__